module.exports = __webpack_public_path__ + "img/banner3.6b1ad56e.jpg";